
<i
  class="far"
  :class="check.class"
  :title="check.title()"
  v-on:click="check.toggle()"
></i>
